import styled from "styled-components";
import {SliceFillDefaultBox} from "./slice-fill.default.box";
import {baseColors} from "../../../../../themes/definitions/casino777/base-colors";

export const SliceFillCasino777Box = styled(SliceFillDefaultBox)`
    filter: drop-shadow(0px 4px 12px ${baseColors.base03});
`;